var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5381 7.2654L4.8457 2.87109",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3848 12.8519V6.07839C16.3845 5.78143 16.3053 5.48978 16.1553 5.23268C16.0053 4.97559 15.7897 4.7621 15.5301 4.61362L9.54709 1.22687C9.28722 1.07824 8.99245 1 8.69238 1C8.39231 1 8.09754 1.07824 7.83767 1.22687L1.85471 4.61362C1.5951 4.7621 1.37947 4.97559 1.22946 5.23268C1.07944 5.48978 1.00031 5.78143 1 6.07839V12.8519C1.00031 13.1488 1.07944 13.4405 1.22946 13.6976C1.37947 13.9547 1.5951 14.1682 1.85471 14.3167L7.83767 17.7034C8.09754 17.852 8.39231 17.9303 8.69238 17.9303C8.99245 17.9303 9.28722 17.852 9.54709 17.7034L15.5301 14.3167C15.7897 14.1682 16.0053 13.9547 16.1553 13.6976C16.3053 13.4405 16.3845 13.1488 16.3848 12.8519Z",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23145 5.19922L8.69305 9.47499L16.1547 5.19922",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69238 17.9975V9.46289",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.385 17.5934C18.934 17.5934 21.0004 15.5464 21.0004 13.0213C21.0004 10.4962 18.934 8.44922 16.385 8.44922C13.8359 8.44922 11.7695 10.4962 11.7695 13.0213C11.7695 15.5464 13.8359 17.5934 16.385 17.5934Z",
    fill: "white",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3857 11.1895V14.8471",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5391 13.0234H18.2314",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInventory);
export default __webpack_public_path__ + "static/media/addInventory.fb76b2002a5dfd41ad3b98c71e050f36.svg";
export { ForwardRef as ReactComponent };